
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agenda",
      function () {
        return require("private-next-pages/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agenda"])
      });
    }
  